import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { ApiRoutes } from "integrations/aws/common/Routes";
import useFetch from "integrations/hooks/useFetch";
import FormDataContext from "integrations/contexts/FormDataContext";
import { toAWSRequest } from "integrations/aws/common/formDataAdapter";
import KinesisSetupStep from "./KinesisSetupStep";
const StepItems = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;
const KinesisSetupSteps = ({ onSuccess, onError }) => {
  const { formData } = useContext(FormDataContext);
  const [streamArn, setStreamArn] = useState(null);
  const [roleArn, setRoleArn] = useState(null);
  const [createSubsciptionProgress, setCreateSubsciptionUrl] = useFetch(
    null,
    () => {
      onSuccess();
    },
    "POST",
    toAWSRequest(formData, {
      region: formData.awsCloudWatchAwsRegion.value,
      log_group_name: formData.awsCloudWatchAwsGroupName.value,
      filter_name: "filter-name",
      // TODO: Use unique filter name
      filter_pattern: "",
      destination_stream_arn: streamArn,
      role_arn: roleArn
    })
  );
  const [createPolicyProgress, setCreatePolicyUrl] = useFetch(
    null,
    (response) => {
      setRoleArn(response.role_arn);
      setCreateSubsciptionUrl(ApiRoutes.INTEGRATIONS.AWS.KINESIS_AUTO_SETUP.CREATE_SUBSCRIPTION);
    },
    "POST",
    toAWSRequest(formData, {
      region: formData.awsCloudWatchAwsRegion.value,
      stream_name: formData.awsCloudWatchKinesisStream.value,
      stream_arn: streamArn
    })
  );
  const [createStreamProgress, setCreateStreamUrl] = useFetch(
    null,
    (response) => {
      setStreamArn(response.stream_arn);
      setCreatePolicyUrl(ApiRoutes.INTEGRATIONS.AWS.KINESIS_AUTO_SETUP.CREATE_SUBSCRIPTION_POLICY);
    },
    "POST",
    toAWSRequest(formData, {
      region: formData.awsCloudWatchAwsRegion.value,
      stream_name: formData.awsCloudWatchKinesisStream.value
    })
  );
  useEffect(() => {
    setCreateStreamUrl(ApiRoutes.INTEGRATIONS.AWS.KINESIS_AUTO_SETUP.CREATE_STREAM);
  }, [setCreateStreamUrl]);
  useEffect(() => {
    if (createStreamProgress.error || createPolicyProgress.error || createSubsciptionProgress.error) {
      onError();
    }
  }, [createStreamProgress.error, createPolicyProgress.error, createSubsciptionProgress.error, onError]);
  return /* @__PURE__ */ React.createElement(StepItems, null, /* @__PURE__ */ React.createElement(KinesisSetupStep, { label: "Kinesis Stream", progress: createStreamProgress }), /* @__PURE__ */ React.createElement(KinesisSetupStep, { label: "Subscription Policy", progress: createPolicyProgress }), /* @__PURE__ */ React.createElement(KinesisSetupStep, { label: "Subscription", progress: createSubsciptionProgress }));
};
export default KinesisSetupSteps;
